<script setup lang="ts">
import { useAppStateStore } from '@shared/stores/app-state';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

import KgrIcon from './KgrIcon.vue';

// 1:1 port of the Angular `kgr-offline-message` (customer-apps/app-state). Shows an offline
// banner while offline + visible; once back online it swaps to a "you're online again" banner
// with a reload button, which is cleared on the next navigation.
const appState = useAppStateStore();
const router = useRouter();

const isOffline = computed(() => !appState.isOnline);

const showOfflineMessage = ref(false);
const showOnlineMessage = ref(false);

watch(
    [isOffline, () => appState.isVisible],
    ([offline, visible]) => {
        showOnlineMessage.value = showOfflineMessage.value && !offline;
        showOfflineMessage.value = offline && visible;
    },
    { immediate: true },
);

router.afterEach(() => {
    showOnlineMessage.value = false;
});

function reload() {
    window.location.reload();
}
</script>

<template>
    <div class="kgr-block">
        <div
            class="kgr-alert kgr-alert--warning kgr-hidden kgr-hidden--fadeInOnUnhidden"
            :class="{ 'is-unhidden': showOfflineMessage }"
        >
            {{ $t('Sie sind gerade offline. Einige Anwendungsbereiche benötigen eine Internetverbindung, um korrekt zu funktionieren.') }}
        </div>
        <div
            class="kgr-alert kgr-alert--success kgr-alert--noIcon kgr-hidden kgr-hidden--fadeInOnUnhidden"
            :class="{ 'is-unhidden': showOnlineMessage }"
        >
            <div class="kgr-postfix kgr-postfix--gutters">
                <div class="kgr-postfix__fluid">
                    {{ $t('Sie sind jetzt wieder online.') }}
                </div>
                <div class="kgr-postfix__fixed">
                    <button
                        type="button"
                        class="kgr-button kgr-button--icon"
                        @click="reload"
                    >
                        <KgrIcon name="refresh" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
